/* tslint:disable */
/* eslint-disable */

import { exists } from '../runtime';

/**
 * @export
 * @interface ControlLargeMarketClientSearchResult
 */
export interface ControlLargeMarketClientSearchResult {
    name: string;
    client_id: string;
    created: string;
    org_id?: string;
    active?: boolean;
    /**
     * When Control last recorded a vulnerability scan for this client.
     * @type {string | number}
     * @memberof ControlLargeMarketClientSearchResult
     */
    last_scanned?: string | number;
    /**
     * Vulnerability-scanning process id for this client.
     * @type {string}
     * @memberof ControlLargeMarketClientSearchResult
     */
    process_id?: string;
}

export function ControlLargeMarketClientSearchResultFromJSON(
    json: any,
): ControlLargeMarketClientSearchResult {
    return ControlLargeMarketClientSearchResultFromJSONTyped(json, false);
}

export function ControlLargeMarketClientSearchResultFromJSONTyped(
    json: any,
    _ignoreDiscriminator: boolean,
): ControlLargeMarketClientSearchResult {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: json['name'],
        client_id: json['client_id'],
        created: json['created'],
        org_id: json['org_id'] ?? undefined,
        active: json['active'] ?? undefined,
        last_scanned: json['last_scanned'] ?? undefined,
        process_id: json['process_id'] ?? undefined,
    };
}

export function ControlLargeMarketClientSearchResultToJSON(
    value?: ControlLargeMarketClientSearchResult | null,
): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        client_id: value.client_id,
        created: value.created,
        org_id: value.org_id,
        active: value.active,
        last_scanned: value.last_scanned,
        process_id: value.process_id,
    };
}

export function instanceOfControlLargeMarketClientSearchResult(
    value: object,
): boolean {
    return exists(value, 'name') && exists(value, 'client_id') && exists(value, 'created');
}
